var modals = (function($) {

	var $anchors;
	var $body;
	var anim_speed = 300;

	var init = function() {
		setup_modals();
	};

	var has_open_modal = function() {
		return $('html body').hasClass('modal-open');
	};

	var setup_modals = function() {
		$anchors = $('a.open-modal');
		$body = $('body');

		if ($anchors.length > 0) {
			$anchors.each(function(index, item) {
				var $anchor = $(item);

				if (!$anchor.hasClass('modals-setup')) {
					attach_handlers($anchor);
				}
			});

			$(document).on('keydown', function(e) {
				if (e.key === 'Escape') {
					close_modals();
				}
			});
		}
	};

	var attach_handlers = function($anchor) {
		var $modal = $('html ' + $anchor.attr('href'));

		$anchor.on('click', {modal : $modal}, open_modal_event);
		$anchor.addClass('modals-setup');

		$modal.find('a.close-modal').on('click', {modal : $modal}, close_modal_event);
		$body.find('.site-overlay').on('click', close_modals);

		$anchor.trigger('attached-modal-handlers');
	};

	var open_modal_event = function(e) {
		$body.addClass('modal-open');

		e.data.modal.trigger('modal-opening', {modal : e.data.modal});

		e.data.modal.fadeIn(anim_speed);

		setTimeout(function() {
			e.data.modal.trigger('modal-open', {modal : e.data.modal});
		}, anim_speed);

		e.preventDefault();
	};

	var close_modal_event = function(e) {
		if (!$body.hasClass('modal-open')) {
			return;
		}

		$body.removeClass('modal-open');

		e.data.modal.trigger('modal-closing', {modal : e.data.modal});

		e.data.modal.fadeOut(anim_speed);

		setTimeout(function() {
			e.data.modal.trigger('modal-closed', {modal : e.data.modal});
		}, anim_speed);

		e.preventDefault();
	};

	var close_modals = function(e) {
		if (!$body.hasClass('modal-open')) {
			return;
		}

		var $modals = $('.crate-modal');

		$modals.each(function(index, item) {
			close_modal($(item), false);
		});

		$body.removeClass('modal-open');

		if (e) {
			e.preventDefault();
		}
	};

	var open_modal = function($modal) {
		$body.addClass('modal-open');

		$modal.find('a.close-modal').on('click', {modal : $modal}, close_modal_event);
		$body.find('.site-overlay').on('click', close_modals);

		$modal.trigger('modal-opening', {modal : $modal});
		$modal.fadeIn(anim_speed);
		setTimeout(function() {
			$modal.trigger('modal-open', {modal : $modal});
		}, anim_speed);
	};


	var close_modal = function($modal, remove_body_class) {
		if (!$body.hasClass('modal-open')) {
			return;
		}

		if (remove_body_class === true) {
			$body.removeClass('modal-open');
		}

		$modal.trigger('modal-closing', {modal : $modal});
		$modal.fadeOut(anim_speed);

		setTimeout(function() {
			$modal.trigger('modal-closed');
		}, anim_speed);
	};

	$(document).ready(init);

	return {
		init : init,
		close_modals : close_modals,
		close_modal : close_modal,
		open_modal : open_modal,
		has_open_modal : has_open_modal,
	};

})(jQuery);

module.exports = modals;
